/**
 * Token storage utilities
 */
const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const USER_KEY = 'user';
const TENANT_KEY = 'tenant';
export const tokenStorage = {
    getAccessToken: () => {
        return localStorage.getItem(ACCESS_TOKEN_KEY);
    },
    setAccessToken: (token) => {
        localStorage.setItem(ACCESS_TOKEN_KEY, token);
    },
    getRefreshToken: () => {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    },
    setRefreshToken: (token) => {
        localStorage.setItem(REFRESH_TOKEN_KEY, token);
    },
    setTokens: (accessToken, refreshToken) => {
        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    },
    clearTokens: () => {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    },
    getUser: () => {
        const data = localStorage.getItem(USER_KEY);
        return data ? JSON.parse(data) : null;
    },
    setUser: (user) => {
        localStorage.setItem(USER_KEY, JSON.stringify(user));
    },
    getTenant: () => {
        const data = localStorage.getItem(TENANT_KEY);
        return data ? JSON.parse(data) : null;
    },
    setTenant: (tenant) => {
        localStorage.setItem(TENANT_KEY, JSON.stringify(tenant));
    },
    clearAll: () => {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
        localStorage.removeItem(REFRESH_TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
        localStorage.removeItem(TENANT_KEY);
    },
};
//# sourceMappingURL=storage.js.map